import { FC, useEffect } from "react";
import { useField } from "formik";
import { FieldGroup, IFormProps } from ".";
import UserInfoListViewModel from "../Models/UserInfoListViewModel";
import { ParticipantSelect } from "src/Controls";

interface IUserInfoListControlProps extends IFormProps {
	model: UserInfoListViewModel;
};

const UserInfoListControl: FC<IUserInfoListControlProps> = ( { model, readOnly, setFieldValue } ) => {

	const [ inputProps,,helperProps ] = useField( model.FullPath );

	useEffect( () => {
		helperProps.setValue( model.Value, true );
	// eslint-disable-next-line
	}, [ model.Value ] );

	const onChangeValue = ( value: any ) => setFieldValue( model.FullPath, value );

	return (
		<FieldGroup
			hidden={ !model.ControlVisibility }
			name={model.FullPath} 
			title={model.Caption} 
			width={model.Width ?? 12}
			readOnly={ !model.ControlEnabling || readOnly }
			isInvalid={model.notValidClass} 
			errorMsg={model.errorMessage}
			isRequired={model.IsMandatory}
			tooltip={model.Tooltip}
		>
			<ParticipantSelect 
				{...inputProps}
				disabled={readOnly || !model.ControlEnabling}
				setValue={ (c: any) => onChangeValue(c.id) }
			/>
		</FieldGroup>
	);
};

export default UserInfoListControl;
